import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRequest =
        error.config?.url?.includes('/login') ||
        error.config?.url?.includes('/register');
      if (!isAuthRequest) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const taskSetService = {
  getTaskSets: async () => {
    const response = await api.get('/task-sets');
    return response.data;
  },
  createTaskSet: async (data) => {
    const response = await api.post('/task-sets', data);
    return response.data;
  },
  updateTaskSet: async (id, data) => {
    const response = await api.put(`/task-sets/${id}`, data);
    return response.data;
  },
  deleteTaskSet: async (id) => {
    const response = await api.delete(`/task-sets/${id}`);
    return response.data;
  },
};
